<template>
  <div class="filling-goods-div">
    <div style="padding-top: 5px;font-size: 16px">出库</div>
    <div class="filling-goods-head">
      <div class="filling-goods-head-div">
       
        <div class="head-input-div">
          <div style="width: 20%;text-align: left">出库单号:</div>
          <input style="width: 80%" readonly="readonly" v-model="out_num" />
        </div>
        <div class="head-input-div">
          <div style="width: 20%;text-align: left">行数:</div>
          <input style="width: 80%" readonly="readonly" :value="data.length" />
        </div>
          <div class="head-input-div">
          <div style="width: 20%;text-align: left">明细码:</div>
          <input style="width: 80%" readonly="readonly" v-model="mxm" />
        </div>
      </div>
    </div>
    <span style="color: red" v-if="hostcs">测试服</span>
    <div
      style="display: flex;justify-content: space-between;align-items: center"
      v-if="outNumber === '未出库'"
    >
      <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
      <div v-if="orderNumberType">
        <!-- 判断上有单号是否有值  -->
        <!-- 扫描货号 -->
       
        <!-- 扫描明细码 -->
        <input
          id="gck_number-input"
          class="get-input"
          @keyup.enter="detailCode(detailCodeValue)"
          ref="getIDInpot"
          placeholder="扫描明细码"
          v-model="detailCodeValue"
          v-on:blur="hideMessage('orderNumber')"
          readonly
          autocomplete="off"
        />
      </div>
      <div v-else>
        <!-- 上有单号有值 就进行下边的扫描 -->
        <!-- 扫描货号 -->
        <input
          v-if="inputChangeClick"
          id="reel-input"
          class="get-input"
          @keyup.enter="add_mx(gck_number_data)"
          ref="getGCKInpot"
          placeholder="扫描货号条码"
          v-model="gck_number_data"
          v-on:blur="hideMessage('gck_number_data')"
          readonly
          autocomplete="off"
        />
        <!-- 再一次扫描明细码 -->
        <input
          v-if="!inputChangeClick"
          id="gck_number-input"
          class="get-input"
          ref="getGCKInpot"
          @keyup.enter="detailCode2(detailCodeValue2)"
          placeholder="扫描明细码"
          v-model="detailCodeValue2"
          v-on:blur="hideMessage('gck_number_data')"
          readonly
          autocomplete="off"
        />
      </div>
    </div>

    <div :style="style">
      <div class="goods-info-two" v-for="(i, index) in data" :key="index">
        <div style="width: 100%;text-align: right;">
          <van-icon name="cross" @click="deleteData(index)" style="margin: 5px 5px 5px 0" />
        </div>
        <div class="info-order-h">
          <div style="width: 50%;display: flex;align-items: center">
            <div class="right-twenty">货号</div>
            <div class="data-order">{{ i.number }}</div>
          </div>
          <div style="width: 50%;display: flex;align-items: center">
            <div class="right-twenty">产品名称</div>
            <div class="data-order">{{ i.name }}</div>
          </div>
        </div>
        <div class="sp-db-h">
          <div class="right-twenty">规格</div>
          <div class="data-order">{{ i.size }}</div>
        </div>
        <div class="info-order-h">
          <div style="width: 50%;display: flex;">
            <div class="right-twenty">数量</div>
            <div class="data-order">
              <input v-model="i.num" v-on:blur="countAll()" style="width: 2rem" />
              <!--<span v-else>{{i.num}}</span>-->
            </div>
          </div>
          <div style="width: 50%;display: flex;">
            <div class="right-twenty">计量单位</div>
            <div class="data-order">{{ i.unit }}</div>
          </div>
        </div>
         <div class="sp-db-h">
          <div class="right-twenty">明细码</div>
          <div class="data-order">{{ i.mxm }}</div>
        </div>
      </div>
    </div>
    <!--<div style="text-align: left;font-size: 16px">共计{{allcount}}米</div>-->
    <div class="filling-goods-bottom" style="display: flex;">
      <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
      <van-button
        v-if="outNumber === '未出库'"
        type="info"
        class="bottom-button"
        @click="fillingGoods()"
      >确认出库</van-button>
      <van-button
        v-if="outNumber !== '未出库'"
        type="default"
        class="bottom-button"
        style="background-color: darkgray"
      >确认出库</van-button>
      <van-button
        v-if="outNumber !== '未出库'"
        type="info"
        class="bottom-button"
        @click="revocation(id)"
      >撤销出库</van-button>
      <van-button
        v-if="outNumber === '未出库'"
        type="default"
        class="bottom-button"
        style="background-color: darkgray"
      >撤销出库</van-button>
      <van-button
        type="warning"
        class="bottom-button"
        style="margin: 0"
        @click="more_show = true"
      >更多</van-button>
    </div>
    <van-popup v-model="more_show" position="bottom">
      <div class="more-class">
        <van-icon name="scan" size="1rem" @click="gourl('fillingGoods')" />
      </div>
      <div class="more-class" style="padding: 10px 0">
        <span style="font-size: 20px;" @click="all_delete()">整单删除</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  name: "cleanOutInfo",
  data() {
    return {
      hostcs: false,
      more_show: false,
      orderNumberType: true,
      ray: "扫描中",
      id: "",
      order_value: "",
      data: [],
      style: "",
      allcount: 0,
      orderNumber: "",
      out_num: "",
      infoType: "1111",
      gck_number_data_haveAll: {},
      gck_number_data: "",
      fillingGoodsType: true,
      revocationType: true,
      outNumber: "未出库",
      type: {},
      detailCodeValue: "", //明细码的 v-model
      changeInput: false, //切换扫码的模式
      count: 0, //判断是否是第一次
      inputChangeClick: true,
      detailCodeValue2: "", //输入第二次明细码的 v-model
      username:null,
      mxm:"",//明细码
      vueType:"DirectOutbound"
    };
  },
  mounted() {
    let user_data = JSON.parse(window.localStorage.getItem("userinfo"))
    if( typeof user_data === undefined){
      this.username = this.$store.state.username
    }else{
      this.username = user_data
    }
    if (this.$route.query.id !== undefined) {
      this.getIdData(this.$route.query.id);
    }
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.style =
      "text-align: left;width: 100%;height: " + h * 0.73 + "px;overflow:scroll";
    setTimeout(() => {
      this.countAll();
      if (this.outNumber === "未出库") {
        this.focus();
      }
    }, 500);
    if (window.location.host.indexOf("cspda") !== -1) {
      this.hostcs = true;
    }

    setTimeout(() => {
      let xhOutData = this.get(this.APIOBJ.xhOut, {
        // relevance: document.querySelector(".number").value.trim(),
      });
      xhOutData.then((res) => {
        this.type.type = res.data.data;
      });
    }, 1000);
  },
  methods: {
    changeShow() {
      this.inputChangeClick = !this.inputChangeClick;
    },
    detailCode2(value) {
      this.get(this.APIOBJ.zdXHout, { number: value ,username:this.username}).then((res) => {
        let data = res.data.data;
        let isPush = true; //默认不push
        this.mxm = data.mxm;
        if (res.data.status !== 0) {
          if (this.data.length > 0) {
            this.data.forEach((item) => {
              //去重
              if (item.number === data.number) {
                item.num *= 1;
                item.num += parseInt(data.num);
                isPush = false;
              }
            });
            if (isPush) {
              this.data.unshift(data);
            }
          } else {
            this.data.unshift(data);
          }
          this.data = this.data.reverse()
        }

        Toast(res.data.msg);
      });
      this.detailCodeValue2 = "";
    },
    detailCode(value) {
      // 扫描明细码
      this.get(this.APIOBJ.zdXHout, { number: value ,username:this.username}).then((res) => {
        if (res.data.status == 1) {
          let data = res.data.data;
          if (this.count > 0 && this.orderNumber !== data.relevance) {
            Toast("上游单据不一致");
            return;
          }
          this.count++;
          this.orderNumber = data.relevance;
          this.order_value = data.type;
          this.orderNumberType = false;
          //获取到上游单号
          // let isPush = true; //默认不push
          // if (this.data.length > 0) {
          //   this.data.forEach((item) => {
          //     //去重
          //     if (item.number === data.number) {
          //       item.num *= 1;
          //       item.num += parseInt(data.num);
          //       isPush = false;
          //     }
          //   });
          // if (isPush) {
          //   this.data.unshift(data);
          // }
          // } else {
          //   this.data.unshift(data);
          // }
        }
        Toast(res.data.msg);
      });
      this.detailCodeValue = ""; //清空
    },
    async goGck() {
      let xhOutData = await this.get(this.APIOBJ.xhOut, {
        relevance: this.orderNumber.trim(),
        username:this.username
      });
      if (xhOutData.data.status !== 0) {
        Toast(xhOutData.data.msg);
        this.orderNumberType = false;
        this.order_value = xhOutData.data.data;
        setTimeout(() => {
          this.gck_input();
        }, 0);
      } else {
        this.orderNumberType = true;
        this.orderNumber = "";
        Toast(xhOutData.data.msg);
      }
    },
    gck_input() {
      this.$refs.getGCKInpot.focus();
      this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getGCKInpot.removeAttribute("readonly");
      }, 200);
    },
    all_delete() {
      if (this.outNumber === "已出库") {
        Toast("已出库不能删除");
        return;
      }
      Dialog.confirm({
        message: "确定要删除当前出库单吗？",
      }).then(async () => {
        let s = await this.get(this.APIOBJ.delXhout, { id: this.id ,username:this.username});
        Toast(s.data.msg);
        if (s.data.status === 1) {
          setTimeout(() => {
            this.$router.push("/home");
          }, 500);
        }
      });
    },
    countAll() {
      //计算总量
      // this.allcount = 0
      // for(let i of this.data){
      //   this.allcount += parseFloat(i['all_num'])
      // }
      // this.allcount = this.allcount.toFixed(1)
    },
    hideMessage(title) {
      if (title === "orderNumber") {
        if (this.orderNumber === "") {
          this.ray = "暂停中";
        }
      }
      if (title === "gck_number_data") {
        if (this.gck_number_data === "") {
          this.ray = "暂停中";
        }
      }
    },
    holdRay() {
      this.ray = "扫描中";
      if (this.orderNumber === "") {
        // this.inputChangeClick = true;
        this.focus();
      } else if (this.gck_number_data === "") {
        // this.inputChangeClick = false;
        this.gck_input();
      }
    },
    focus() {
      this.$refs.getIDInpot.focus();
      this.$refs.getIDInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getIDInpot.removeAttribute("readonly");
      }, 200);
    },
    gourl(url) {
      url = "http://www.lcyjfz.com/home/scan?url=" + url;
      window.location.href = url;
    },
    async add_mx(gck_number_title) {
      if (this.gck_number_data_haveAll[gck_number_title] !== undefined) {
        for (let i of this.data) {
          if (i.number === gck_number_title) {
            i.num++;
          }
        }
        this.gck_number_data = "";
        return;
      }
      this.gck_number_data_haveAll[gck_number_title] = "";
      let type = this.type.type ? this.type.type : this.order_value;
      let xhOuts_data = {
        relevance: this.orderNumber,
        number: gck_number_title,
        // type: this.order_value,
        type: type,
        username:this.username
      };
      let packing = await this.get(this.APIOBJ.xhOuts, xhOuts_data);
      let data = packing.data.data;
      let isPush = false;
      if (packing.data.status !== 0) {
        //对数据进行加工
        if (this.data.length != 0) {
          if (data instanceof Object) {
            this.data.forEach((item) => {
              item.num *= 1;
              if (item.number === data.number) {
                item.num += parseInt(data.num);
                isPush = true;
              }
            });
          }
          if (!isPush) {
            //判断是否需要添加
            this.data.unshift(data);
          }
        } else {
          //如果数组中没有数据直接添加
          this.data.unshift(data);
        }
      } else {
        Toast(packing.data.msg);
      }
      this.gck_input();
      this.gck_number_data = "";
      this.countAll();
    },
    deleteData(index, gck_number_data) {
      if (this.outNumber === "已出库") {
        Toast("已出库不能删除");
        return;
      }
      Dialog.confirm({
        message: "确定要删除该明细吗？",
      }).then(() => {
        this.data.splice(index, 1);
        delete this.gck_number_data_haveAll[gck_number_data];
        setTimeout(() => {
          this.countAll();
        }, 0);
      });
    },
    go_index() {
      Dialog.confirm({
        message: "确定要回首页吗？",
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          // on cancel
        });
    },
    go_scan_url() {
      let url =
        "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
      window.location.href = url;
    },
    async getIdData(id) {
      //订单详情
      //订单详情页
      let idData = await this.get(this.APIOBJ.out_xhdetail, { id ,username:this.username});
      if (idData.data.data.out.xhstatus === "1") {
        this.changeInput = false;
      } else {
        this.changeInput = true;
      }

      let obj = {};
      obj[idData.data.data.out_detail[0].number] =
        idData.data.data.out_detail[0];
      obj[idData.data.data.out_detail[0].number].num--;
      if (idData.data.data.out_detail instanceof Array) {
        idData.data.data.out_detail.forEach((item) => {
          if (Object.keys(obj).includes(item.number)) {
            if (obj[item.number].number === item.number) {
              obj[item.number].num++;
            } else {
              obj[item.number] = item;
            }
          } else {
            obj[item.number] = item;
          }
        });
      }
      let resultArr = [];
      for (let key in obj) {
        resultArr.push(obj[key]);
      }
      this.data = resultArr.reverse(); //对数据进行倒叙
      //出库单列表 进入出库单的数据处理
      this.outNumber = idData.data.data.out.status;
      this.orderNumber = idData.data.data.out.relevance;
      this.orderNumberType = false;
      this.infoType = "";
      this.id = id;
      this.out_num = idData.data.data.out.out_num;
    },
    async getFGIdData(FGid) {},
    async fillingGoods() {
      //确出库方法
      if (this.data.length === 0) {
        return;
      }
      // if (!this.fillingGoodsType) {
      //   Toast("不要连续出库");
      //   return;
      // }
      this.fillingGoodsType = false;
      let out_info;
      if (this.id === "") {
        let data = {};

        if (this.changeInput) {
          data = {
            relevance: this.orderNumber,
            type: this.order_value,
            size: "",
            num: "",
            name: "",
            unit: "",
            number: "",
            username:this.username,
            mxm:"",
            types:this.vueType
          };
        } else {
          data = {
            relevance: this.orderNumber,
            type: this.order_value,
            size: "",
            num: "",
            name: "",
            unit: "",
            number: "",
            xhstatus: "1",
            username:this.username,
            mxm:"",
            types:this.vueType
          };
        }
        for (let i of this.data) {
          if (i["num"] === "") {
            Toast("数量不能为空");
            this.fillingGoodsType = true;
            return;
          }
          data.size += i.size + ";";
          data.number += i.number + ",";
          data.num += i.num + ",";
          data.unit += i.unit + ",";
          data.name += i.name + ",";
          data.username += ","
          data.mxm += i.mxm + ','
          data.types += i.type + ','
          
        }
        for (let i in data) {
          data[i] =
            data[i].substring(data[i].length - 1) === ","
              ? data[i].substring(0, data[i].length - 1)
              : data[i];
              data[i] =
              data[i].substring(data[i].length - 1) === ";"
                ? data[i].substring(0, data[i].length - 1)
                : data[i];
        }
        out_info = await this.get(this.APIOBJ.doXhout, data);
        if (out_info.data.status === 0) { 
          Toast(out_info.data.msg);
          return;
        }
        this.id = out_info.data.data.id;
        this.fillingGoodsType = true;
        this.outNumber = out_info.data.data.status;
        this.infoType = "";
        this.out_num = out_info.data.data.out_num;
      } else {
        let data = {};
        if (this.changeInput) {
          data = {
            id: this.id,
            size: "",
            num: "",
            name: "",
            unit: "",
            number: "",
            username:this.username,
            mxm:"",
            types:this.vueType
          };
        } else {
          data = {
            id: this.id,
            size: "",
            num: "",
            name: "",
            unit: "",
            number: "",
            xhstatus: "1",
            username:this.username,
            mxm:"",
            types:this.vueType
          };
        }
        for (let i of this.data) {
          if (i["num"] === "") {
            Toast(`${i.name}数量为空`);
            this.fillingGoodsType = true;
            return;
          }
          data.size += i.size + ";";
          data.number += i.number + ",";
          data.num += i.num + ",";
          data.unit += i.unit + ",";
          data.name += i.name + ",";
          data.username += ","
          data.mxm += i.mxm + ","
          data.types += i.type + ','
        }
        for (let i in data) {
          if (i !== "id") {
            data[i] =
              data[i].substring(data[i].length - 1) === ","
                ? data[i].substring(0, data[i].length - 1)
                : data[i];
            data[i] =
              data[i].substring(data[i].length - 1) === ";"
                ? data[i].substring(0, data[i].length - 1)
                : data[i];
          }
        }
        out_info = await this.get(this.APIOBJ.editXhout, data);
      }

      // if (out_info.data.status === 0) {
      //   Toast("成功");
      // }
      if (out_info.data.status === 0) {
        Toast(out_info.data.msg);
        return;
      }
      this.id = out_info.data.data.id;
      this.fillingGoodsType = true;
      this.outNumber = out_info.data.data.status;
      this.infoType = "";
      Toast(out_info.data.msg);
    },
    async revocation(id) {
      //撤销出库的方法
      if (!this.revocationType) {
        return;
      }
      this.revocationType = false;
      let out_info = await this.get(this.APIOBJ.backXhout, { id: id ,username:this.username});
      this.outNumber = "未出库";
      if (out_info.data.status === 1) {
        Toast("已撤销");
      }
      this.infoType = "1111";
      this.revocationType = true;
      this.fillingGoodsType = true;
    },
  },
};
</script>

<style lang="less">
.head-input-div {
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;
}
.filling-goods-head {
  padding: 10px 0;
}
.filling-goods-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -10px;
}
.info-order {
  width: 100%;
  display: flex;
  background-color: white;
  margin: 5px 0;
  padding: 10px 0;
}
.goods-info-two {
  margin-top: 10px;
  background-color: #f2f2f2;
  padding-bottom: 10px;
}
.bottom-button {
  width: 25%;
}
.info-order-h {
  width: 100%;
  display: flex;
  padding-top: 5px;
}
.order-info-input {
  border-radius: 5px;
  border: 1px solid #444444;
  text-align: center;
  width: 4.5rem;
}
.info-order-data {
  width: 65%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-order-title {
  width: 35%;
}
.an-niu {
  border-radius: 5px;
  font-size: 12px;
}
.right-twenty {
  width: 1.6rem;
  margin: 0 15px;
  text-align: left;
}
.goods-info {
  margin-top: 10px;
  height: 300px;
  background-color: #f2f2f2;
}
.SbuttonDiv {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0 -10px;
}
.sp-db-h {
  width: 100%;
  padding-top: 10px;
  display: flex;
}
.more-class {
  border-top: 0.5px solid #444444;
}
</style>
